export interface ArtistInterface {
    id: number;
    documentId: string;
    artistKey: string;
    name: string;
    danceable: boolean;
    instagram: string | null;
    tag: string | null;
    venmo: string | null;
    spotify: string | null;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
}

export class Artist implements ArtistInterface {
    id: number;
    documentId: string;
    artistKey: string;
    name: string;
    danceable: boolean;
    instagram: string | null;
    tag: string | null;
    venmo: string | null;
    spotify: string | null;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;

    constructor(params: Partial<ArtistInterface> = {}) {
        this.id = params.id ?? 0;
        this.documentId = params.documentId ?? "";
        this.artistKey = params.artistKey ?? "";
        this.name = params.name ?? "";
        this.danceable = params.danceable ?? false;
        this.instagram = params.instagram ?? null;
        this.tag = params.tag ?? null;
        this.venmo = params.venmo ?? null;
        this.spotify = params.spotify ?? null;
        this.createdAt = params.createdAt ?? "";
        this.updatedAt = params.updatedAt ?? "";
        this.publishedAt = params.publishedAt ?? "";
    }
}